import aaave from './aaave.svg';
import aampl from './aampl.svg';
import aavax from './aavax.svg';
import abal from './abal.svg';
import abat from './abat.svg';
import abusd from './abusd.svg';
import acrv from './acrv.svg';
import adai from './adai.svg';
import adpi from './adpi.svg';
import aenj from './aenj.svg';
import aeth from './aeth.svg';
import aeurs from './aeurs.svg';
import afei from './afei.svg';
import afrax from './afrax.svg';
import agusd from './agusd.svg';
import aknc from './aknc.svg';
import alend from './alend.svg';
import alink from './alink.svg';
import amana from './amana.svg';
import amatic from './amatic.svg';
import amkr from './amkr.svg';
import apax from './apax.svg';
import arai from './arai.svg';
import aren from './aren.svg';
import arenfil from './arenfil.svg';
import arep from './arep.svg';
import asnx from './asnx.svg';
import astkaave from './astkaave.svg';
import asusd from './asusd.svg';
import atusd from './atusd.svg';
import auni from './auni.svg';
import ausdc from './ausdc.svg';
import ausdp from './ausdp.svg';
import ausdt from './ausdt.svg';
import awbtc from './awbtc.svg';
import aweth from './aweth.svg';
import awmatic from './awmatic.svg';
import axsushi from './axsushi.svg';
import ayfi from './ayfi.svg';
import azrx from './azrx.svg';
import aftm from './aftm.svg';
import aone from './aone.svg';
import awftm from './awftm.svg';
import awone from './awone.svg';
import aghst from './aghst.svg';
import ashushi from './ashushi.svg';
import asteth from './asteth.svg';
import aens from './aens.svg';
import aust from './aust.svg';

interface Images {
  [name: string]: string;
}

export default {
  asusd,
  asnx,
  atusd,
  ausdt,
  ausdc,
  adai,
  abusd,
  aeth,
  arep,
  abat,
  alink,
  amkr,
  amana,
  azrx,
  aknc,
  awbtc,
  alend,
  aenj,
  aren,
  aaave,
  ayfi,
  astkaave,
  agusd,
  auni,
  aweth,
  acrv,
  abal,
  axsushi,
  amatic,
  arenfil,
  aampl,
  arai,
  apax,
  adpi,
  aavax,
  afrax,
  afei,
  ausdp,
  aeurs,
  awmatic,
  aftm,
  aone,
  awftm,
  awone,
  aghst,
  ashushi,
  asteth,
  aens,
  aust,
} as Images;
